


















































import {Component, Watch,} from "vue-property-decorator";
import {BaseList} from "@/core/components/BaseList";
import {Medicine} from "@/core/services/MedicaPro/models";
import {Api} from "@/core/services/MedicaPro/Api";

@Component
export default class MedicineListPage extends BaseList {

    modelName = 'medicine';
    items: Medicine[] = [];
    headers = [
        {text: 'Navn', value: 'name', sortable: false},
        {text: '', value: 'actions', sortable: false},
    ];

    public created() {
        super.created();
    }

    public mounted() {
        super.mounted();
    }

    @Watch('$route')
    public parseRoute() {
        this.getItems(true, true);
    }

    protected getItems(doItems = true, doCount = false) {
        // Get options from DataTable
        const options: any = this.options;

        // Mark as Loading
        this.loading = true;

        // Prepare API call
        const API = Api.medicines().get();
        if (this.search && this.search.length) {
            API
                .search('name', this.search);
        }

        if (doItems) {
            API
                .limit(options.itemsPerPage)
                .offset(options.itemsPerPage * (options.page - 1))
                .orderAsc('name')
                .find(items => {
                    this.items = items;
                    this.loading = false;
                });
        }

        // Count total amount of items
        if (doCount) {
            API.count(count => {
                this.totalItems = count;
            });
        }
    }

    public deleteItem(item: Medicine) {
        this.$confirm(`Do you want to delete "${item.name}"?`).then(res => {
            if (res) {
                Api.medicines().deleteById(item.id!).delete(item => {
                    this.getItems(true, true);
                });
            }
        });
    }

}
